import { franc } from 'franc-min';

export const isDutchText = (text: string | undefined | null): boolean => {
  if (!text) {
    return false;
  }
  const cleaned = text
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return franc(cleaned) === 'nld';
};
